import AbstractProvidedClass from "../shared/AbstractProvidedClass";
import { TIP_BAR_HEIGHT } from "../shared/constants";

export default class TipBar extends AbstractProvidedClass {
    display() {
        this.p.stroke(0);
        this.p.strokeWeight(1);
        this.p.fill(255);
        this.p.rect(-1, this.p.height - TIP_BAR_HEIGHT, this.p.width, TIP_BAR_HEIGHT + 1);
        this.p.noStroke();
        this.p.textSize(14);
        this.p.fill(0);
        this.p.textAlign(this.p.LEFT, this.p.BOTTOM);
        this.p.text(this.tools.currentTool.getTips(), 10, this.p.height - 2);
    }
}
